module.exports = __webpack_public_path__ + "static/media/ok.0a2c73b5.mp3";